/* The Glow Up Guide — About page. Reveal-on-scroll + offset-aware in-page jump. Theme-editor safe. */
(function(){
  document.documentElement.classList.add('gugab-js');

  function reveal(root){
    var design = window.Shopify && window.Shopify.designMode;
    var items = root.querySelectorAll('.gugab-reveal');
    if(design || !('IntersectionObserver' in window)){
      items.forEach(function(el){ el.classList.add('gugab-in'); });
      return;
    }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('gugab-in'); io.unobserve(e.target); } });
    }, { threshold:.12, rootMargin:'0px 0px -40px 0px' });
    items.forEach(function(el){ io.observe(el); });
  }

  // Intrinsic header height so in-page jumps land below a sticky / auto-hide header.
  function topInset(){
    var sels = ['#shopify-section-header','sticky-header','.header-wrapper','.site-header','.section-header','.header__wrapper','header'];
    for(var i=0;i<sels.length;i++){
      var el = document.querySelector(sels[i]);
      if(el){ var h = el.offsetHeight; if(h > 0 && h < 300) return h; }
    }
    return 0;
  }
  function setScrollMargins(){
    var off = topInset() + 20;
    document.querySelectorAll('[data-gugab-anchor]').forEach(function(el){ el.style.scrollMarginTop = off + 'px'; });
  }

  // Delegated in-page jumps (e.g. "Why I made this" -> story), offset below the header.
  document.addEventListener('click', function(e){
    var a = e.target.closest ? e.target.closest('[data-gugab-jump]') : null;
    if(!a) return;
    var id = a.getAttribute('data-gugab-jump');
    var el = document.getElementById(id);
    if(!el) return;
    e.preventDefault();
    setScrollMargins();
    var off = topInset() + 20;
    var top = el.getBoundingClientRect().top + window.pageYOffset - off;
    if(top < 0) top = 0;
    try{ window.scrollTo({ top: top, behavior:'smooth' }); }catch(err){ window.scrollTo(0, top); }
  });

  function init(root){
    reveal(root || document);
    setScrollMargins();
  }

  if(document.readyState !== 'loading'){ init(document); }
  else { document.addEventListener('DOMContentLoaded', function(){ init(document); }); }

  window.addEventListener('resize', setScrollMargins);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
